



























import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import ProcessGraphCard from '@/components/organizationDashboard/processGraph/ProcessGraphCard.vue';
import { AggregationResults } from '@/@types/Organization';

@Component({
  components: {
    ProcessGraphCard,
  },
})
export default class ProcessGraphBase extends Vue {
  @Prop({ required: true })
  private organizationAggregationResults!: AggregationResults[];

  @Watch('organizationAggregationResults')
  private updateOrganizationAggregationResults(newValue: AggregationResults[]) {
    if (newValue.length) {
      this.organizationAggregationResults = newValue;
    }
  }
}
